// import React, {useState } from "react";
// import { useNavigate } from "react-router-dom";

// const LastDetailsSection = ({ labelDetailData }) => {
//   const navigate = useNavigate();
// const [isImageLoaded, setIsImageLoaded] = useState(false); // Track image load state
//   const getLabelText = React.useCallback(
//     (label) => {
//       return labelDetailData?.code === 200
//         ? labelDetailData.data.find((item) => item.vLabel === label)?.tText ||
//             ""
//         : "";
//     },
//     [labelDetailData]
//   );

//   const { heading, subHeading } = React.useMemo(() => {
//     const heading =
//       getLabelText("LBL_HOME_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
//       getLabelText("LBL_ABOUT_US_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
//       getLabelText("LBL_BOOK_NOW_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
//       getLabelText("LBL_CONTACT_US_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
//       getLabelText("LBL_DEEP_CLEANING_READY_FOR_A_THOUGH_HEADING") ||
//       getLabelText(
//         "LBL_MOVE_OUT_MOVE_IN_CLEANING_READY_TO_MAKE_YOUR_MOVE_EASIER_HEADING"
//       ) ||
//       getLabelText(
//         "LBL_POST_EVENT_CLEANING_READY_TO_WRAP_UP_YOUR_EVENT_HEADING"
//       ) ||
//       getLabelText(
//         "LBL_ROUTINE_ONE_TIME_CLEANING_READY_FOR_A_ONE_TIME_REFRESH_HEADING"
//       ) ||
//       getLabelText(
//         "LBL_MOVE_OUT_IN_CLEANING_EDMONTON_LAST_DETAIL_SECTION_TITLE"
//       );

//     const subHeading =
//       getLabelText("LBL_HOME_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
//       getLabelText("LBL_ABOUT_US_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
//       getLabelText("LBL_BOOK_NOW_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
//       getLabelText("LBL_CONTACT_US_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
//       getLabelText("LBL_DEEP_CLEANING_READY_FOR_A_THOUGH_SUB_HEADING") ||
//       getLabelText(
//         "LBL_MOVE_OUT_MOVE_IN_CLEANING_READY_TO_MAKE_YOUR_MOVE_EASIER_SUB_HEADING"
//       ) ||
//       getLabelText(
//         "LBL_POST_EVENT_CLEANING_READY_TO_WRAP_UP_YOUR_EVENT_SUB_HEADING"
//       ) ||
//       getLabelText(
//         "LBL_ROUTINE_ONE_TIME_CLEANING_READY_FOR_A_ONE_TIME_REFRESH_SUB_HEADING"
//       ) ||
//       getLabelText(
//         "LBL_MOVE_OUT_IN_CLEANING_EDMONTON_LAST_DETAIL_SECTION_DESCRIPTION"
//       );

//     return { heading, subHeading };
//   }, [getLabelText]);

//   const handleBookNowClick = () => {
//     navigate("/book-now");
//   };

//   return (
//     <section
//       className="lastdetails-section ptb-100"
//       // style={{ backgroundImage: "url('/assets/images/last-detailsbg.png')" }}
//       style={{ position: "relative", overflow: "hidden" }}
//     >
//      <img
//           src={'/assets/images/last-detailsbg.webp'}
//           alt="MopForce Banner"
//           fetchPriority="high"
//           decoding="async"
//           loading="eager"
//           onLoad={() => setIsImageLoaded(true)} // Image loaded callback
//           style={{
//             width: "100%",
//             height: "100%",
//             objectFit: "cover",
//             position: "absolute",
//             top: 0,
//             left: 0,
//             zIndex: -1,
//             filter: isImageLoaded ? "none" : "blur(10px)", // Apply blur initially
//             transition: "filter 0.3s ease-out", // Smooth transition once image is loaded
//           }}
//         />
//       <div className="container">
//         <div className="row align-items-center">
//           <div className="col-xl-8 col-lg-9 col-md-12">
//             <div className="about-contentDiv">
//               <h2 className="main-title">{heading}</h2>
//               <p>{subHeading}</p>
//               <button
//                 className="success-orangebtn"
//                 type="button"
//                 onClick={handleBookNowClick}
//               >
//                 Book Now
//               </button>
//             </div>
//           </div>
//         </div>
//       </div>

//       <img
//         className="img-fluid last-details-shape"
//         // src="/assets/images/last-details-shapeimg.png"
//         src="/assets/images/last-details-shapeimg.webp"
//         // width="641"
//         // height="714"
//         width="564"
//         height="628"
//         alt="Shape"
//         loading="lazy"
//       />
//     </section>
//   );
// };

// export default LastDetailsSection;


import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

const LastDetailsSection = ({ labelDetailData }) => {
  const navigate = useNavigate();
  const [isImageLoaded, setIsImageLoaded] = useState(false);

  const getLabelText = React.useCallback(
    (label) => {
      return labelDetailData?.code === 200
        ? labelDetailData.data.find((item) => item.vLabel === label)?.tText || ""
        : "";
    },
    [labelDetailData]
  );

  const { heading, subHeading, bgImage } = React.useMemo(() => {
    // 🔹 Move-out labels
    const moveOutTitle = getLabelText(
      "LBL_MOVE_OUT_IN_CLEANING_EDMONTON_LAST_DETAIL_SECTION_TITLE"
    );

    const moveOutDesc = getLabelText(
      "LBL_MOVE_OUT_IN_CLEANING_EDMONTON_LAST_DETAIL_SECTION_DESCRIPTION"
    );

    const heading =
      getLabelText("LBL_HOME_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
      getLabelText("LBL_ABOUT_US_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
      getLabelText("LBL_BOOK_NOW_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
      getLabelText("LBL_CONTACT_US_NEVER_WAIT_FOR_A_CLEANING_HEADING") ||
      getLabelText("LBL_DEEP_CLEANING_READY_FOR_A_THOUGH_HEADING") ||
      getLabelText(
        "LBL_MOVE_OUT_MOVE_IN_CLEANING_READY_TO_MAKE_YOUR_MOVE_EASIER_HEADING"
      ) ||
      getLabelText(
        "LBL_POST_EVENT_CLEANING_READY_TO_WRAP_UP_YOUR_EVENT_HEADING"
      ) ||
      getLabelText(
        "LBL_ROUTINE_ONE_TIME_CLEANING_READY_FOR_A_ONE_TIME_REFRESH_HEADING"
      ) ||
      moveOutTitle ||
      "";

    const subHeading =
      getLabelText("LBL_HOME_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
      getLabelText("LBL_ABOUT_US_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
      getLabelText("LBL_BOOK_NOW_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
      getLabelText("LBL_CONTACT_US_NEVER_WAIT_FOR_A_CLEANING_SUB_HEADING") ||
      getLabelText("LBL_DEEP_CLEANING_READY_FOR_A_THOUGH_SUB_HEADING") ||
      getLabelText(
        "LBL_MOVE_OUT_MOVE_IN_CLEANING_READY_TO_MAKE_YOUR_MOVE_EASIER_SUB_HEADING"
      ) ||
      getLabelText(
        "LBL_POST_EVENT_CLEANING_READY_TO_WRAP_UP_YOUR_EVENT_SUB_HEADING"
      ) ||
      getLabelText(
        "LBL_ROUTINE_ONE_TIME_CLEANING_READY_FOR_A_ONE_TIME_REFRESH_SUB_HEADING"
      ) ||
      moveOutDesc ||
      "";

    // 🔥 Dynamic image logic
    let bgImage = "/assets/images/last-detailsbg.webp"; // default

    if (moveOutTitle || moveOutDesc) {
      bgImage = "/assets/images/landing/edmonton-clean-home-cta.png";
    }

    return { heading, subHeading, bgImage };
  }, [getLabelText]);

  const handleBookNowClick = () => {
    navigate("/book-now");
  };

  return (
    <section
      className="lastdetails-section ptb-100"
      style={{ position: "relative", overflow: "hidden" }}
    >
      <img
        src={bgImage}
        alt="MopForce Banner"
        fetchPriority="high"
        decoding="async"
        loading="eager"
        onLoad={() => setIsImageLoaded(true)}
        style={{
          width: "100%",
          height: "100%",
          objectFit: "cover",
          position: "absolute",
          top: 0,
          left: 0,
          zIndex: -1,
          filter: isImageLoaded ? "none" : "blur(10px)",
          transition: "filter 0.3s ease-out",
        }}
      />

      <div className="container">
        <div className="row align-items-center">
          <div className="col-xl-8 col-lg-9 col-md-12">
            <div className="about-contentDiv">
              <h2 className="main-title">{heading}</h2>
              <p>{subHeading}</p>
              <button
                className="success-orangebtn"
                type="button"
                onClick={handleBookNowClick}
              >
                Book Now
              </button>
            </div>
          </div>
        </div>
      </div>

      <img
        className="img-fluid last-details-shape"
        src="/assets/images/last-details-shapeimg.webp"
        width="564"
        height="628"
        alt="Shape"
        loading="lazy"
      />
    </section>
  );
};

export default LastDetailsSection;
